import { fetchAdminStats } from '@/api/admin';
import AdminSummaryCards from '@/components/stats/admin-summary-cards';
import ClientsChart from '@/components/stats/clients-chart';
import PeriodFilter from '@/components/stats/period-filter';
import ProfitsChart from '@/components/stats/profits-chart';
import TopBuildsChart from '@/components/stats/top-builds-chart';
import TopWorkersClientsChart from '@/components/stats/top-workers-clients-chart';
import TopWorkersProfitChart from '@/components/stats/top-workers-profit-chart';
import DropperFunnelSection from '@/components/stats/dropper-funnel-section';
import { Spinner } from '@/components/ui/spinner';
import type { IAdminStats, StatsPeriod } from '@/entities/admin-stats.entity';
import { PageScroll } from '@/layouts/page-layout';
import { useEffect, useState } from 'react';

export default function AdminStatsPage() {
	const [period, setPeriod] = useState<StatsPeriod>('week');
	const [stats, setStats] = useState<IAdminStats | null>(null);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		let cancelled = false;
		fetchAdminStats(period)
			.then(data => {
				if (!cancelled) setStats(data);
			})
			.finally(() => {
				if (!cancelled) setLoading(false);
			});
		return () => {
			cancelled = true;
		};
	}, [period]);

	function handlePeriodChange(next: StatsPeriod) {
		if (next === period) return;
		setPeriod(next);
		setStats(null);
		setLoading(true);
	}

	return (
		<PageScroll contentClassName='p-2 flex flex-col gap-3'>
			<PeriodFilter period={period} onChange={handlePeriodChange} />

			{loading || !stats ? (
				<div className='flex justify-center py-12'>
					<Spinner />
				</div>
			) : (
				<>
					<AdminSummaryCards totals={stats.totals} />
					<ClientsChart data={stats.clientsOverTime} />
					<ProfitsChart data={stats.profitsOverTime} />
					<TopBuildsChart data={stats.topBuilds} />
					<TopWorkersClientsChart data={stats.topWorkersByClients} />
					<TopWorkersProfitChart data={stats.topWorkersByProfit} />
					<DropperFunnelSection />
				</>
			)}
		</PageScroll>
	);
}
